<!--
  DepositOperationFormModal: alta de operaciones manuales de depósito.

  ENTRADA
    Props: no tiene.
    Métodos públicos (por ref):
      add(type)   Abre el alta. type: 'add-manual', 'sub-manual' o 'transferencia'.
      close()     Cierra el modal sin confirmar.

  SALIDA
    Eventos:
      @saved(response)   Se guardó. La vista recarga lo que corresponda.
    Efectos:
      Guarda con agregarOperacion. GENERA MOVIMIENTOS REALES DE STOCK en m_deposits_operations_activity.

  USOS
    Vista: <DepositOperationFormModal ref="operationForm" @saved="filterOperations()" />
    Ingreso:        this.$refs.operationForm.add('add-manual')
    Egreso:         this.$refs.operationForm.add('sub-manual')
    Transferencia:  this.$refs.operationForm.add('transferencia')
    Hoy se invoca desde deposits/staff/crudOperations.vue: botones y ?new=1&mode= de la paleta de comandos.

  DEPENDENCIAS Y PERMISOS
    Componentes: cpbtDetailDeposit/detail.
    No controla permisos: quien lo invoca decide si el usuario puede abrirlo.
-->
<template>
  <div>
    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close      
            size="xl"
            :key="modal.form._id"
            :id="modal.form._id">                  
      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <form-wizard  title=""
                    subtitle=""
                    nextButtonText="Siguiente"
                    backButtonText="Atrás"
                    finishButtonText="Guardar"
                    color="#2f353a"
                    shape="tab"
                    @on-complete="save"
                    class="crud-operations-wizard">

        <tab-content title="General" icon="fa fa-edit" :before-change="operationValidDetailGeneral">          
          <b-row>                    
            <b-col md="4">
              <b-form-group label="Fecha">
                <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
              </b-form-group>            
            </b-col>    
           
            <b-col md="12">
              <b-form-group label="Observaciones">
                <app-textarea                
                  v-model="crud.form.observations"
                  placeholder="Ingresar las observaciones..."
                  rows="3"
                  max-rows="6"
                ></app-textarea>
              </b-form-group>
            </b-col>                          
          </b-row>              
        </tab-content>

        <tab-content title="Detalle" icon="fa fa-list" :before-change="operationValidDetailItems">          
          <b-row>
            <b-col lg="12" md="12" sm="12">                                  
              <Detail @load-detail-products="setDetailItems($event, 'products')" 
                      @load-detail-products-compound="setDetailItems($event, 'productsCompound')" 
                      :operation="crud.form"
                      :detailProducts="crud.form.detailProducts"
                      :detailProductsCompound="crud.form.detailProductsCompound"
                      :allowMultipleProducts="crud.form.reference == 'add-manual'"
                      :allowInlineDetailEdit="crud.form.reference == 'add-manual'"/>
            </b-col>        
          </b-row>
        </tab-content>
      </form-wizard>
      
      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancel()"><AppIcon name="x" class="mr-1" />Cancelar</b-button>              
      </div>                
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import Helper from '@/handler/helper'
  import Detail from '@/components/inc/cpbtDetailDeposit/detail.vue'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  export default {
    name: 'DepositOperationFormModal',
    components: {
      Detail,
      FormWizard,
      TabContent,
    },
    data: () => {
      return {
        crud: {
          form: {
            id: 0,
            date: '',                        
            type: null,          
            type_id: 0,              
            number: 0,                       
            observations: '',            
            staff_id: 0,            
            detailProducts: [],
            detailProductsCompound: [],    
            reference: '',          
          },            
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
        },
      }
    },
    methods: {
      // API PUBLICA PARA LA VISTA
      close() {
        this.modal.form.active = false
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: options.size || 'sm',
          buttonSize: options.buttonSize || 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      // ABM MAIN
      add(type) {
        this.crud.form.id = 0           
        this.crud.form.date = moment().format('YYYY-MM-DD')        
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()        
        this.crud.form.detailProducts = []
        this.crud.form.detailProductsCompound = []
        this.crud.form.reference = type       

        this.searchVoucher()
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Operación"
        this.modal.form.active = true
      },       
      save() {
        this.confirmDialog('¿Desea continuar con la operación?', {
          title: 'Guardar Operación',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          icon: 'save',
        })
        .then(value => {
          if (value) {          
            let loader = this.$loading.show();
            
            var result = null
            if (this.crud.form.id) {
              result = serviceAPI.editarOperacion(this.crud.form);
            } else {
              result = serviceAPI.agregarOperacion(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.$emit('saved', response)
              this.$awn.success("Operación guardad con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },          
      cancel() {
        this.confirmDialog('¿Desea cancelar la operación?', {
          title: 'Cancelar Operación',
          okTitle: 'SI',
          cancelTitle: 'NO',
          danger: true,
        })
        .then(value => {
          if (value) {        
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })   
      },
      setDetailItems(event, type) {         
        var detail = Array.isArray(event) ? event.map((element) => {
          element.location_id = element.location ? element.location.id : 0
          return element
        }) : []

        if(type=="products") {
          this.crud.form.detailProducts = detail
        } 
        if(type=="productsCompound") {          
          this.crud.form.detailProductsCompound = detail
        }              
      },         
      operationValidDetailGeneral() {        
        return true;        
      },
      operationValidDetailItems() {
          if( this.crud.form.detailProducts.length || 
              this.crud.form.detailProductsCompound.length) { 
            return true;
          } else {
            this.$awn.alert("No se cargó ningún item");
            return false;
          }
      },

      // SELECT VOUCHER 
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.reference) {
            var result = serviceAPI.obtenerVoucherByReference({
              'reference': this.crud.form.reference,              
            });
            result.then((response) => {                               
              this.crud.form.type = response.data                            
              this.crud.form.number = response.data.number  
              
              if( this.crud.form.type ) {              
                this.modal.form.title = this.crud.form.type.name                
                this.modal.form.title = this.modal.form.title + ' #' + this.crud.form.number
              }
                          
            })           
          }
        } 
      },
    }
  }
</script>
<style>
  .crud-operations-wizard .wizard-header {
    padding: 0px;
  }  
  .crud-operations-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-operations-wizard .wizard-card-footer .wizard-footer-left,
  .crud-operations-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-operations-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-operations-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-operations-wizard .wizard-footer-left .wizard-btn::before,
  .crud-operations-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-operations-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-operations-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-operations-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-operations-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-operations-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-operations-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-operations-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-operations-wizard .wizard-footer-left,
    .crud-operations-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-operations-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-operations-wizard .wizard-footer-left > span,
    .crud-operations-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-operations-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
</style>
